import React from 'react';
import { IconProps } from './types';

const PhoneDisabledIcon: React.FC<IconProps> = props => {
  const { height = '16', width = '16' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13294_83951)">
        <path
          d="M4.43991 9.69305L5.39324 8.73971C5.01991 8.25305 4.69324 7.73971 4.41324 7.19305L5.87991 5.72638C6.06658 5.53971 6.11991 5.27971 6.04658 5.04638C5.79991 4.29971 5.66658 3.49971 5.66658 2.66638C5.66658 2.29971 5.36658 1.99971 4.99991 1.99971H2.66657C2.29991 1.99971 1.99991 2.29971 1.99991 2.66638C1.99991 5.31971 2.91324 7.75971 4.43991 9.69305ZM6.31991 11.5664C8.24658 13.093 10.6866 13.9997 13.3332 13.9997C13.6999 13.9997 13.9999 13.6997 13.9999 13.333V11.0064C13.9999 10.6397 13.6999 10.3397 13.3332 10.3397C12.5066 10.3397 11.6999 10.2064 10.9532 9.95971C10.7199 9.87971 10.4532 9.93971 10.2732 10.1197L8.80658 11.5864C8.26658 11.3064 7.75324 10.9864 7.27324 10.613L15.0732 2.81305L14.1266 1.87305L1.87324 14.133L2.81324 15.073L6.31991 11.5664Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_13294_83951">
          <rect width="16" height="16" fill="white" transform="matrix(-1 0 0 1 16 0)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default PhoneDisabledIcon;
